import { render, staticRenderFns } from "./userInfoDc.vue?vue&type=template&id=711c4d54&scoped=true"
import script from "./userInfoDc.vue?vue&type=script&lang=js"
export * from "./userInfoDc.vue?vue&type=script&lang=js"
import style0 from "./userInfoDc.vue?vue&type=style&index=0&id=711c4d54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711c4d54",
  null
  
)

export default component.exports